import IMG from '@assets/dashboard';
import { formatNumber, getLocalStorage } from '@helpers';
import spcgLogo from '@themes/images/spcg.svg';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';

import { Text } from '../style';
import { Style } from './styleBottom';

const generateCO2Data = (pvGeneration, co2) => {
  const language = getLocalStorage('LANGUAGE');
  const TYPE_LOCALES = {
    en: 'TONNES',
    jp: (
      <>
        {' '}
        t-CO<sub className='text-Co2'>2</sub>
      </>
    ),
  };

  if (typeof co2 !== 'number')
    return {
      number: '-',
      type: TYPE_LOCALES[language],
    };

  const value = pvGeneration * co2;
  let total = value / (1000 * 1000 * 1000);
  const ton = 'TONNES';
  let type = ton;

  return {
    number: numeral(total).format('0,0.00'),
    type:
      type === ton && getLocalStorage('LANGUAGE') === 'en' ? (
        type
      ) : (
        <>
          t-CO<sub className='text-Co2'>2</sub>
        </>
      ),
  };
};

export const Bottom = ({ co2, currency, co2Reduction, co2ReductionTotal, pvGenerationDay, pvGenerationTotal, isEng, totalSavingDay, totalSavingLife  }) => {
  const { t } = useTranslation();
  
  const { type } = generateCO2Data(pvGenerationDay, co2);
  const { type: typeTotal } = generateCO2Data(pvGenerationTotal, co2);

  const displayCo2Reduction = formatNumber(co2Reduction)
  const displayCo2ReductionTotal = formatNumber(co2ReductionTotal)
  const displayTotalSavingDay   = formatNumber(totalSavingDay)
  const displayTotalSavingLife = formatNumber(totalSavingLife)

  return (
    <Style $top={isEng ? '5.5%' : '4.5%'}>
      <div className='column-1'>
        <img className='leaf' src={IMG['leaf.svg']} alt={IMG['leaf.svg']} />
        <img className='box' src={IMG['co2-box.svg']} alt={IMG['co2-box.svg']} />
        <div className='text'>
          {isEng ? (
            <>
              <Text $maxSize='1.3' $minSize='20' top='5%'>
                CO<sub className='text-Co2'>2</sub>
                <label className='space'>{t('bottom.reduction')}</label>
              </Text>
              <div className='flex'>
                <Text $maxSize='2' $minSize='30'>
                  {displayCo2Reduction} {type} {t('bottom.today')}
                </Text>
              </div>
            </>
          ) : (
            <>
              <Text $maxSize='1.3' $minSize='20' top='3%'>
                {t('bottom.co2_1')}CO<sub className='text-Co2'>2</sub>
                {t('bottom.co2_2')}
              </Text>
              <div className='flex'>
                <Text $maxSize='2.4' $minSize='36' top='0%'>
                  {displayCo2Reduction} {type}
                </Text>
              </div>
            </>
          )}
          <Text $maxSize='1.3' $minSize='20' top={isEng ? '1%' : '0%'}>
            {t('bottom.total')} : {displayCo2ReductionTotal} {typeTotal}
          </Text>
        </div>
      </div>
      <div className='column-2'>
        <img className='coin' src={IMG['coin.svg']} alt={IMG['coin.svg']} />
        <div className='animation' />
        <div className='text'>
          <div className='container-label-currency'>
            <Text $maxSize='1.8' $minSize='32'>
              {t('bottom.savingMoney')} :
            </Text>
            <Text $maxSize='2.6' $minSize={isEng ? '38' : '42'} left='8px' lh='40px'>
              {displayTotalSavingDay} THB
            </Text>
          </div>
          <Text $maxSize='1.8' $minSize='32' top={isEng ? '0%' : '-1%'} style={{ marginTop: '20px '}}>
            {t('bottom.totalSave')} : {displayTotalSavingLife} THB
          </Text>
        </div>
        <img className='logo' src={spcgLogo} alt={spcgLogo} />
      </div>
    </Style>
  );
};
